module.exports = __webpack_public_path__ + "img/game.24cfd8f2.svg";